<template>
  <v-toolbar
    flat
    color="transparent">
    <v-spacer></v-spacer>
    <custom-button
      v-if="mixValidaScopesActions(1)"
      label="Nueva"
      iconText="mdi-plus"
      tipo="agregar"
      @click="nuevo">
    </custom-button>
  </v-toolbar>
</template>

<script>
import CustomButton from '@/components/buttons/Button.vue';

export default {
  name: 'ToolBarEjecucionConfiguracionFirmas',
  components: {
    CustomButton,
  },
  data() {
    return {};
  },
  methods: {
    nuevo() {
      this.$emit('nuevaPlantilla');
    },
  },
};
</script>

<style lang="scss">

</style>
